(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/button/assets/javascripts/button.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/button/assets/javascripts/button.trinidad.js'); "use strict";

(() => {

  "use strict";


  var __webpack_require__ = {};





  (() => {

    __webpack_require__.n = module => {
      var getter = module && module.__esModule ?
      () => module['default'] :
      () => module;

      __webpack_require__.d(getter, {
        a: getter
      });


      return getter;
    };

  })();





  (() => {

    __webpack_require__.d = (exports, definition) => {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (() => {
    __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

  })();



  var __webpack_exports__ = {}; 

  __webpack_require__.d(__webpack_exports__, {
    "default": () =>
    javascripts_button
  });

  ; 

  const external_PropTypes_namespaceObject = window["PropTypes"];

  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);

  ; 

  const _excluded = ["block", "children", "circle", "Component", "className", "doubleLines", "elemRef", "focus", "iconPosition", "inverted", "size", "thin", "transparent"];

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }



  const Button = _ref => {
    let {
      block,
      children,
      circle,
      Component,
      className,
      doubleLines,
      elemRef,
      focus,
      iconPosition,
      inverted,
      size,
      thin,
      transparent
    } = _ref,
        props = _objectWithoutProperties(_ref, _excluded);

    const classNames = ['btn', "btn-".concat(size)].concat(className ? className.split(' ') : []);
    block && classNames.push('btn-block');

    if (transparent) {
      inverted && classNames.push('btn-transparent-inverted focus-inverted');
      !inverted && classNames.push('btn-transparent-default');
      thin && classNames.push('btn-thin');
    } else {
      inverted && classNames.push('btn-inverted');
      focus && classNames.push('btn-green');
      !focus && classNames.push('btn-default');
    }

    if (circle) {
      classNames.push('btn-circle');
    }

    if (iconPosition) {
      classNames.push('btn-icon');
      classNames.push("btn-icon-".concat(iconPosition));
    }

    if (doubleLines) {
      classNames.push('btn-double-lines');
    } 


    if (children.type && children.type.displayName === 'Link') {
      return _objectSpread(_objectSpread({}, children), {}, {
        props: _objectSpread(_objectSpread({}, children.props), {}, {
          className: classNames.join(' '),
          children: React.createElement("span", {
            className: "btn-link-text"
          }, children.props.children)
        })
      });
    }

    if ((!Component || Component === 'button') && props.href) {
      Component = 'a';
      props.type = null;
    }

    if (Component === 'button' && !props.type) {
      props.type = 'button';
    }

    return React.createElement(Component, _extends({
      className: classNames.join(' ')
    }, elemRef ? {
      ref: elemRef
    } : {}, props), React.createElement("span", {
      className: "btn-link-text"
    }, children));
  };

  Button.defaultProps = {
    block: false,
    circle: false,
    className: '',
    Component: 'button',
    elemRef: null,
    focus: false,
    inverted: false,
    size: 300,
    thin: false,
    transparent: false,
    type: 'button'
  };

  const javascripts_button = Button;
  ((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactButton = __webpack_exports__.default;
})();
 })(window);